export const categories = [
    'Music',
    'Movies',
    'Sports',
    'Tech',
    'Fashion'
]